import React, { useEffect, useState, useRef } from "react";
import Loginbtn from "../../../../admin/components/common/loginbtn";
import { LOGO_IMG } from "../../../../utills/image-constant";
import { useLocation, useNavigate } from "react-router-dom";
import { API_RESPONSE } from "../../../../utills/app-constant";
import { toastEmitter } from "../../../../utills/utilities";
import { userLogin, userOtpVerify } from "../../../../services/api-services";
import { USERROUTES } from "../../../routes/url-constant";
import { useDispatch } from "react-redux";
import {
    setloggedEmployeerReducer,
} from "../../../../admin/hooks/redux/slice/logged-employee";
import {
    setemployeeAccessTokenTokenReducer,
} from "../../../../admin/hooks/redux/slice/employee-access-token";

const UserOtp = () => {
    const [OTP, setOTP] = useState(new Array(6).fill(""));
    const inputRefs = useRef([]);
    const [disabled, setDisabled] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    let Email = location.state?.email;

    const handleChange = (e, index) => {
        let value = e.target.value;
        if (!/^\d*$/.test(value)) return; // Allow only numbers

        const newOtp = [...OTP];
        newOtp[index] = value.slice(0, 1); // Ensure only one digit per input
        setOTP(newOtp);

        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus(); // Move to next input
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...OTP];
            if (!newOtp[index] && index > 0) {
                inputRefs.current[index - 1]?.focus(); // Move focus to previous input
            }
            newOtp[index] = "";
            setOTP(newOtp);
        }
    };

    useEffect(() => {
        setDisabled(OTP.join("").length !== 6);
    }, [OTP]);

    const handleOtpVerify = async () => {
        setDisabled(true);
        try {
            const response = await userOtpVerify(Email, OTP.join(""));
            if (response?.data?.responseCode !== 200) {
                toastEmitter("error", response?.data?.message);
                resetOtp();
            } else {
                toastEmitter("success", response?.data?.message);
                dispatch(setloggedEmployeerReducer(response?.data?.responseBody));
                dispatch(setemployeeAccessTokenTokenReducer(response?.data?.responseBody?.accessToken));
                navigate(USERROUTES.USERPROFILEINTRODUCTION);
            }
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
            resetOtp();
        } finally {
            setDisabled(false);
        }
    };

    const handleResendOtp = async () => {
        try {
            const response = await userLogin(Email);
            toastEmitter(response?.data?.responseCode === 200 ? "success" : "error", response?.data?.message);
        } catch (err) {
            toastEmitter("error", API_RESPONSE.MESSAGE_503);
        }
    };

    const resetOtp = () => {
        setOTP(new Array(6).fill(""));
        inputRefs.current[0]?.focus(); // Set focus to the first input
    };

    return (
        <div>
            <div className="caspera_login_account_content d-flex justify-content-center align-items-center">
                <div className="card forget-div rounded-4 shadow-sm p-5 pt-4 pb-4 border-0">
                    <div className="card-body">
                        <div className="d-flex justify-content-center align-items-center">
                            <img src={LOGO_IMG} className="img-fluid mb-4 logo_img" alt="logo" />
                        </div>
                        <h5 className="card-text text-center">Enter Verification Code</h5>
                        <p className="card-text text-center mb-1 textfont12">
                            We have sent an OTP code to your email address <strong>{Email}</strong>
                        </p>
                        <p className="card-text text-center mb-1 textfont12">
                            Enter the OTP code below to verify.
                        </p>
                        <div className="row">
                            <div className="col-12 otp-box d-flex justify-content-center">
                                {OTP.map((data, index) => (
                                    <input
                                        ref={(el) => (inputRefs.current[index] = el)}
                                        type="text"
                                        autoComplete="off"
                                        className="form-control mt-2 me-2 otp-input text-center"
                                        key={index}
                                        maxLength={1}
                                        value={data}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                    />
                                ))}
                            </div>
                        </div>
                        <Loginbtn
                            className="submitbtn textfont14 mt-3"
                            handleClick={handleOtpVerify}
                            type="submit"
                            btnName="Verify OTP"
                            disablebtn={disabled}
                        />
                        <p className="mt-2 cursor-pointer">
                            If you haven't received OTP
                            <span className="text-danger" onClick={handleResendOtp}> Resend OTP</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserOtp;
